module.exports = __webpack_public_path__ + "img/invoice-zy.e40efb01.png";